export default __webpack_public_path__ + "src/images/galleries/0/preface_bg-d973f9.png";